import { FormattedMessage } from 'react-intl'

import { CheckCircleIcon, XCircleIcon } from '@gto/ui/icons/solid'
import { colors } from '@gto/ui/theme/design-tokens'
import { Typography } from '@gto/ui/typography'

import type { RuleId } from '@/pages/auth/utils'
import { passwordRules, passwordRulesList } from '@/pages/auth/utils'

export const PasswordRulesChecker = ({ password }: { password: string }) => {
  const isAllValid = passwordRulesList.every((rule: RuleId) => {
    return passwordRules[rule].safeParse(password).success
  })

  if (isAllValid) {
    return null
  }

  return (
    <div className="flex flex-col gap-2">
      <Typography
        color="text.primary"
        variant="body1"
      >
        <FormattedMessage id="auth.passwordUpdate.rules.title" />
      </Typography>
      <ul className="relative m-0 flex list-none flex-col gap-0.5 p-1">
        {passwordRulesList.map((rule: RuleId) => {
          const isValid = passwordRules[rule].safeParse(password).success

          return (
            <li
              key={rule}
              className="relative flex w-full items-center justify-start p-0 text-left"
            >
              <div className="flex items-center gap-2">
                {isValid ? (
                  <CheckCircleIcon
                    color={colors.primary.main}
                    height={16}
                  />
                ) : (
                  <XCircleIcon
                    color={colors.text.ghost}
                    height={16}
                  />
                )}
                <Typography
                  color={isValid ? 'text.primary' : 'warning'}
                  variant="body1"
                >
                  <FormattedMessage id={`auth.passwordUpdate.rules.${rule}`} />
                </Typography>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
